// src/plugins/jquery.js
import jQuery from 'jquery';

// Make it global
window.jQuery = jQuery;
window.$ = jQuery;

// Optional: expose as default for ES6 imports
export default jQuery;
